import e from "react";
import { useTheme as I, Accordion as T, AccordionItem as h, AccordionButton as k, Flex as C, Heading as b, AccordionIcon as v, AccordionPanel as w, Box as r } from "@chakra-ui/react";
import { RichTextRenderer as a } from "../../atoms/rich-text-renderer/rich-text-renderer.js";
import { LongText as B } from "../long-text/long-text.js";
const L = e.memo(
  ({ accordionItems: o, defaultOpenIndex: i = [], headingLevel: c }) => {
    if (!o.length) return null;
    const {
      element: d,
      icon: l,
      accordionTitleText: m,
      accordionBodyText: s,
      borderStyle: x,
      interactive: p,
      action: { primaryDefault: u, primaryHover: g },
      linkUnderline: f,
      accordionIcon: A,
      accordion: { extraLargePadding: y }
    } = I();
    return /* @__PURE__ */ e.createElement(
      T,
      {
        allowMultiple: !0,
        defaultIndex: i,
        width: "100%"
      },
      o.map(
        (t) => /* @__PURE__ */ e.createElement(
          h,
          {
            key: t.contentId,
            borderBottom: x.default,
            "data-testid": "accordion-item"
          },
          /* @__PURE__ */ e.createElement(
            k,
            {
              paddingY: d.spacingMedium,
              paddingX: 0,
              _hover: { background: p.background }
            },
            /* @__PURE__ */ e.createElement(C, { flex: 1, textAlign: "left" }, /* @__PURE__ */ e.createElement(
              b,
              {
                as: c,
                "data-testid": "accordion-title",
                sx: m
              },
              /* @__PURE__ */ e.createElement(a, { content: t.headline })
            )),
            /* @__PURE__ */ e.createElement(
              v,
              {
                color: l.accent1,
                fontSize: A
              }
            )
          ),
          /* @__PURE__ */ e.createElement(w, { pb: 4, pl: 0 }, /* @__PURE__ */ e.createElement(
            r,
            {
              sx: {
                ...s,
                "& * a": {
                  color: u,
                  textDecoration: f
                },
                "& * a:hover": {
                  textDecoration: "none",
                  color: g
                }
              }
            },
            t.componentId === "accordionItem" && "displayText1" in t && /* @__PURE__ */ e.createElement(a, { content: t.displayText1 }),
            t.componentId === "segmentedAccordionItem" && "segments" in t && /* @__PURE__ */ e.createElement(
              r,
              {
                display: "flex",
                flexDirection: t.segmentsArrangement === "Columns" ? "column" : "row",
                gap: y,
                justifyContent: t.segmentsArrangement === "Columns" ? "initial" : "space-between",
                "data-testid": "segmented-accordion-items"
              },
              t.segments.map((n, E) => /* @__PURE__ */ e.createElement(
                B,
                {
                  variantId: n.variant,
                  textColour: n.textColour,
                  textAlignment: n.textAlignment,
                  markdownContentBody: n.markdownContentBody,
                  key: `segment-${E}`
                }
              ))
            )
          ))
        )
      )
    );
  }
);
export {
  L as Accordion
};
